import WebGLColor, {default as Color} from '../Color';
import Shape from './Shape';
import DrawInfo from '../DrawInfo';
import Matrix4 from '../../../../../foundation/algebra/linear/Matrix4';

abstract class PrimitiveShape implements Shape {

	private transformationMatrix = Matrix4.identity();
	private color: WebGLColor | null = null;

	public constructor (private drawMode: number, private vertexArray: number[]) {}

	/*
	 * Command methods
	 */

	public rotateX (angle: number) {
		this.transformationMatrix.rotateX(angle);
		return this;
	}

	public rotateY (angle: number) {
		this.transformationMatrix.rotateY(angle);
		return this;
	}

	public rotateZ (angle: number) {
		this.transformationMatrix.rotateZ(angle);
		return this;
	}

	public scale (factor: number): this;
	public scale (x: number, y: number, z: number): this;

	public scale (x: number, y?: number, z?: number) {
		if (y === undefined) {
			y = x;
		}

		if (z === undefined) {
			z = x;
		}

		this.transformationMatrix.scale(x, y, z);
		return this;
	}

	public setColor (color: WebGLColor | null) {
		this.color = color;
		return this;
	}

	public setTransformationMatrix (transformationMatrix: Matrix4) {
		this.transformationMatrix = transformationMatrix;
		return this;
	}

	public translate (x: number, y: number, z: number) {
		this.transformationMatrix.translate(x, y, z);
		return this;
	}

	/*
	 * Query methods
	 */

	public abstract copy(): PrimitiveShape;

	public getColor () {
		return this.color;
	}

	public getDrawInfo (defaultColor: Color) {
		return [new DrawInfo(this.vertexArray, this.getColorArray(defaultColor), this.drawMode, this.transformationMatrix)];
	}

	public getTransformationMatrix () {
		return this.transformationMatrix.copy();
	}

	/*
	 * Private methods
	 */

	private getColorArray (defaultColor: WebGLColor) {
		const color = this.color !== null ? this.color : defaultColor;

		const array = color.getArray();

		const numberOfVertices = this.vertexArray.length / 4;
		let colorArray: number[] = [];
		let i: number;
		for (i = 0; i < numberOfVertices; i++) {
			colorArray = colorArray.concat(array);
		}

		return colorArray;
	}
}

export default PrimitiveShape;


// WEBPACK FOOTER //
// ./code/project/pages/components/webGL/shapes/PrimitiveShape.ts